// extracted by mini-css-extract-plugin
module.exports = {"container":"e_zs","poster":"e_As","player":"e_Bs","play":"e_Cs","playBadge":"e_Ds","playIcon":"e_Es","loading":"e_Fs","spin":"e_Gs"};